import { useNavigationType } from 'react-router-dom'
import { handleGraphQLErrors, getTenant, setSessionStorage, removeSessionItem, getSessionStorage } from '../../utils'

export function getInputParams(location) {
  const params = new URLSearchParams(location.search)
  const inputs = params.get('inputs') ? JSON.parse(params.get('inputs')) : { orderBy: '1', orderDir: 'ASC' }
  return inputs
}

export function sortColumnClicked(e, location, navigate, setResults) {
  const inputs = sortColumn(e, location)
  const route = location.pathname.split('/')[2]  // location.pathname is /custom/route
  const queryString = `/custom/${route}?inputs=${JSON.stringify(inputs)}`
  navigate(queryString)
  setResults(null)
}

export function sortColumn(e, location) {
  const inputs = getInputParams(location)
  let columnIndex
  if (!e.target.id) {
    columnIndex = e.target.farthestViewportElement.id
  } else {
    columnIndex = e.target.id
  }
  console.log(`customUtils.sortColumn: columnIndex: ${columnIndex}`)
  let direction = 'ASC'
  if (inputs.orderBy === columnIndex && inputs.orderDir === 'ASC') {
    direction = 'DESC'
  }
  inputs.orderBy = columnIndex
  inputs.orderDir = direction
  return inputs
}

function replaceSingleQuotesInObject(dataObject) {
  const newDataObject = JSON.parse(JSON.stringify(dataObject))
  for (let label in newDataObject) {
    if (typeof newDataObject[label] === 'string' && newDataObject[label].includes('\'')) {
      console.log(`before: ${newDataObject[label]}`)
      newDataObject[label] = newDataObject[label].replace(/'/g, '\'\'')
      console.log(`after: ${newDataObject[label]}`)
    }
  }
  return newDataObject
}

function replaceSingleQuotes(inputs) {
  let newInputs
  if (Array.isArray(inputs)) {
    newInputs = []
    for (let i = 0; i < inputs.length; i++) {
      newInputs[i] = replaceSingleQuotesInObject(inputs[i])
    }
  } else {
    newInputs = replaceSingleQuotesInObject(inputs)
  }
  return newInputs
}

export async function getData(location, gql, gqlDataName, setResults, setGraphQLErrors, uniqueVariable, variableData) {
  let inputs = ''
  if (location) {
    inputs = getInputParams(location)
  }
  const variable = inputs ? 'inputs' : uniqueVariable
  const variableInput = variableData ? variableData : inputs
  console.log('CustomUtils.getData: ', { variable, variableInput })
  try {
    if (variable) {
      const newVariableInput = replaceSingleQuotes(variableInput)
      const { data, errors } = await window.apolloClient.query({ query: gql, variables: { [variable]: newVariableInput } })
      if (data[gqlDataName]) {
        setResults(data[gqlDataName])
      }
      if (errors) {
        if (errors[0].message.includes('Unexpected token')) {
          errors[0].message = 'The data you requested contains extended ASCII characters (a.k.a. characters which are international based or otherwise unreadable by our new system.)  Please contact support@xerdict.com providing case-specific details on this situation (e.g. your system URL and the record you are attempting to edit) for assistance.'
        }
        console.log('errors', errors)
        setGraphQLErrors(errors)
      }
    } else {
      const { data, errors } = await window.apolloClient.query({ query: gql })
      if (data[gqlDataName]) {
        setResults(data[gqlDataName])
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
    }
  } catch(err) {
    console.log('catch', err)
    handleGraphQLErrors(err, setGraphQLErrors)
  }
}

export function reportDate() {
  const date = new Date()
  return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`
}

export function currencyFormatter(currency) {
  const localCurrency = currency ? currency : 'USD'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: localCurrency,
  })
}

export function csvUrl( path, locationForInputs) {
  let inputs = ''
  if (locationForInputs) {
    inputs = `?inputs=${encodeURIComponent(JSON.stringify(getInputParams(locationForInputs)))}`
  }
  return `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/${path}.csv${inputs}`
}

export function stringifyInputs(inputs) {
  const newInputs = JSON.parse(JSON.stringify(inputs))
  for (let key in newInputs) {
    if (!newInputs[key]) {
      delete newInputs[key]
    }
  }
  return JSON.stringify(newInputs)
}

export function initialFormValues(name, navigate, defaultValues) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (useNavigationType() === 'POP') {
    let sessionStorage = getSessionStorage(name)
    if (!sessionStorage) {
      return defaultValues
    } else {
      return JSON.parse(sessionStorage)
    }
  } else {
    removeSessionItem(name)
    return defaultValues
  }
}

export function submitFormValues(name, navigate, inputs, customRoute ) {
  console.log('CustomUtils.submitFormValues', name, inputs, customRoute)
  setSessionStorage(name, JSON.stringify(inputs))
  const url = `/custom/${customRoute}?inputs=${encodeURIComponent(stringifyInputs(inputs))}`
  navigate(url)
}